"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var rebass_1 = require("rebass");
var tema_1 = require("../../tema");
var Grid_1 = require("../Grid");
var Logo_1 = __importDefault(require("../Logo"));
function default_1(_a) {
  var _b = _a.logoHref,
    logoHref = _b === void 0 ? "https://www.x-apps.com.br" : _b;
  return react_1.default.createElement(tema_1.Tema, null, react_1.default.createElement(rebass_1.Flex, {
    sx: {
      backgroundColor: "blue1",
      width: "100vw",
      svg: {
        width: 122,
        display: "block"
      }
    }
  }, react_1.default.createElement(Grid_1.Grid, null, react_1.default.createElement(Grid_1.Column, {
    span: 2
  }, react_1.default.createElement("a", {
    href: logoHref
  }, react_1.default.createElement(Logo_1.default, null))))));
}
exports.default = default_1;